import React from "react";

const fmtMoney = (cents, currency = "usd") =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: currency.toUpperCase() }).format((cents || 0) / 100);

export default function MembershipReceipt({ receipt, onClose }) {
    const paidDate = receipt?.paid_at
        ? new Date(receipt.paid_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })
        : "—";
    return (
        <div
            className="fixed inset-0 bg-black/50 z-[70] flex items-end sm:items-center justify-center px-3 pb-3 sm:p-6"
            onClick={onClose}
            data-testid="receipt-modal"
        >
            <div onClick={e => e.stopPropagation()} className="w-full sm:max-w-md bg-cream border border-burgundy/20 max-h-[85vh] flex flex-col">
                <div className="px-6 pt-6 pb-3 border-b border-burgundy/15">
                    <div className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Purchase receipt</div>
                    <h3 className="mt-1 font-display text-2xl text-burgundy"><span className="italic">Founding</span> 100</h3>
                </div>
                <div className="flex-1 overflow-y-auto px-6 py-5 space-y-3">
                    <Line label="Member" value={`Founding Member #${receipt.founding_member_number}`} testid="receipt-member" />
                    <Line label="Date paid" value={paidDate} testid="receipt-date" />
                    <Line label="Amount" value={fmtMoney(receipt.amount, receipt.currency)} testid="receipt-amount" />
                    <Line label="Credit granted" value={`${fmtMoney(receipt.amount, receipt.currency)} — never expires`} testid="receipt-credit" />
                    {receipt.card_last4 && (
                        <Line
                            label="Payment method"
                            value={`${(receipt.card_brand || "Card").toUpperCase()} •••• ${receipt.card_last4}`}
                            testid="receipt-card"
                        />
                    )}
                    {receipt.reference && (
                        <div className="pt-1" data-testid="receipt-reference">
                            <div className="text-[10px] tracking-[0.32em] uppercase text-ink-muted">Reference</div>
                            <div className="mt-1 font-mono text-[10px] text-ink break-all">{receipt.reference}</div>
                        </div>
                    )}
                    <p className="pt-2 text-xs text-ink-muted leading-relaxed">
                        Your founding fee is held as prepaid credit and applies to any plan at official launch. Refunds available within 30 days via info@youreverafter.com.
                    </p>
                </div>
                <div className="px-6 py-4 border-t border-burgundy/15 space-y-2">
                    {receipt.receipt_url && (
                        <a
                            data-testid="receipt-stripe-link"
                            href={receipt.receipt_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block w-full text-center border border-burgundy text-burgundy uppercase text-[11px] tracking-[0.22em] py-3"
                        >
                            View official card receipt
                        </a>
                    )}
                    <button data-testid="receipt-close-btn" onClick={onClose} className="w-full bg-burgundy text-cream uppercase text-[11px] tracking-[0.22em] py-3">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

function Line({ label, value, testid }) {
    return (
        <div className="flex items-baseline justify-between gap-4" data-testid={testid}>
            <span className="text-[10px] tracking-[0.32em] uppercase text-ink-muted shrink-0">{label}</span>
            <span className="font-display text-base text-burgundy text-right">{value}</span>
        </div>
    );
}
